
<div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
        <router-view />
    </component>
    <ManagerNotification />
</div>
